import React, { useEffect, useState } from "react";
import { getAllBroadcasts, sentBroadcastNotifications } from "../service";

const Broadcasts = () => {
  const [broadcasts, setBroadcasts] = useState([]);

  const [statusFilter, setStatusFilter] = useState("All");
  const [templateFilter, setTemplateFilter] = useState("All");
  const [userFilter, setUserFilter] = useState("");

  useEffect(() => {
    fetchBroadcasts();
  }, []);

  const fetchBroadcasts = async () => {
    try {
      const res = await getAllBroadcasts();
      setBroadcasts(res);
    } catch (err) {
      console.error("Failed to fetch broadcasts", err);
    }
  };

  const handleSendBroadcast = async (broadcastId) => {
    try {
      await sentBroadcastNotifications(broadcastId);
      fetchBroadcasts();
    } catch (err) {
      console.error("Failed to send notifications", err);
      alert("Failed to send notifications");
    }
  };

  const statusOptions = ["All", "sent", "not sent"];
  const templateOptions = [
    "All",
    ...new Set(broadcasts.map((b) => b.template)),
  ];

  const filteredBroadcasts = broadcasts.filter((b) => {
    const userMatch = b.users?.toLowerCase().includes(userFilter.toLowerCase());

    const templateMatch =
      templateFilter === "All" || b.template === templateFilter;

    const statusMatch =
      statusFilter === "All" ||
      (statusFilter === "sent" && b.sent) ||
      (statusFilter === "not sent" && !b.sent);

    return userMatch && templateMatch && statusMatch;
  });

  return (
    <div className="container-fluid mt-4">
      <h2 className="mb-4">Sales Broadcasts</h2>

      <div className="row g-3 mb-4">
        <div className="col-md-2">
          <label className="form-label">Status</label>
          <select
            className="form-select"
            value={statusFilter}
            onChange={(e) => setStatusFilter(e.target.value)}
          >
            {statusOptions.map((status) => (
              <option key={status}>{status}</option>
            ))}
          </select>
        </div>

        <div className="col-md-2">
          <label className="form-label">Template</label>
          <select
            className="form-select"
            value={templateFilter}
            onChange={(e) => setTemplateFilter(e.target.value)}
          >
            {templateOptions.map((template) => (
              <option key={template}>{template}</option>
            ))}
          </select>
        </div>

        <div className="col-md-2">
          <label className="form-label">User (Name / Mobile)</label>
          <input
            type="text"
            className="form-control"
            placeholder="Search user"
            value={userFilter}
            onChange={(e) => setUserFilter(e.target.value)}
          />
        </div>
      </div>

      <div className="table-responsive">
        <table className="table table-bordered table-striped align-middle w-100 mt-2">
          <thead className="table-light">
            <tr>
              <th>Template</th>
              <th>Scheduled Time</th>
              <th>Created At</th>
              <th>Users</th>
              <th>action</th>
            </tr>
          </thead>
          <tbody>
            {filteredBroadcasts.length > 0 ? (
              filteredBroadcasts.map((broadcast) => (
                <tr key={broadcast.id}>
                  <td>{broadcast.template}</td>
                  <td>{broadcast.schedule_time || "-"}</td>
                  <td>{broadcast.created_at}</td>
                  <td>{broadcast.users}</td>
                  <td className="text-center">
                    {!broadcast.sent ? (
                      <button
                        className="btn btn-sm btn-primary"
                        onClick={() => handleSendBroadcast(broadcast.id)}
                      >
                        Send
                      </button>
                    ) : (
                      "-"
                    )}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="6" className="text-center">
                  No broadcasts found.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Broadcasts;
